/*
 * IMPORTS
 */
import React, { useState } from 'react' // Npm: react.js library.
import PropTypes from 'prop-types' // Npm: react.js library.
import { connect } from 'react-redux' // Npm: React Redux for state management.
import { HiPencil, HiTrash } from 'react-icons/hi2' // Npm: React icons.
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText
} from '@mui/material' // Npm: Material-UI components.


/*
 * OBJECTS
 */
const Index = ({
  senderIdDirectoryId,
  senderIdId,
  onSenderIdUpdate,
  onSenderIdDelete,
  PassOnUpdate
}) => {
  // State for menu anchor
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  // Handle menu open
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  // Handle menu close
  const handleClose = () => {
    setAnchorEl(null)
  }

  // Return component.
  return (
    <>
      <IconButton
        onClick={handleClick}
        sx={{
          margin: 'auto',
          borderRadius: '8px',
          color: 'gray.500',
          bgcolor: 'transparent'
        }}>
        <HiPencil size={18} />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >

        <MenuItem
          sx={{ gap: 0 }}
          onClick={() => {
            // Push senderId id to url.
            PassOnUpdate({ senderIdDirectoryId, senderIdId })

            // Execute handler.
            onSenderIdUpdate()

            // Close menu
            handleClose()
          }}
        >
          <ListItemIcon >
            <HiPencil size={18} />
          </ListItemIcon>
          <ListItemText>Edit SenderId</ListItemText>
        </MenuItem>

        <MenuItem
          sx={{ gap: 0 }}
          onClick={() => {
            // Push senderId id to url.
            PassOnUpdate({ senderIdDirectoryId, senderIdId })

            // Execute handler.
            onSenderIdDelete()

            // Close menu
            handleClose()
          }}
        >
          <ListItemIcon >
            <HiTrash size={18} />
          </ListItemIcon>
          <ListItemText>Delete SenderId</ListItemText>
        </MenuItem>
      </Menu>
    </>
  )
}


/*
 * PROPTYPES
 */
Index.propTypes = {
  'senderIdDirectoryId': PropTypes.string,
  'senderIdId': PropTypes.string,
  'onSenderIdUpdate': PropTypes.func,
  'onSenderIdDelete': PropTypes.func,
  'PassOnUpdate': PropTypes.func
}


/*
 * REDUX
 */
const _MapDispatchToProps = __dispatch => ({
  'PassOnUpdate': u => __dispatch({ 'type': 'PASS_ON_UPDATE', 'PassOn': u })
})


/*
 * EXPORT
 */
export default connect(void 0, _MapDispatchToProps)(Index)
